import { render } from "./Overlay.vue?vue&type=template&id=bcd9cc1a&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"

import "./Overlay.vue?vue&type=style&index=0&id=bcd9cc1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bcd9cc1a"

export default script